import {
  TextField,
  Flex,
  LoadingButton,
} from '@elementary/common-ui/components';
import SendRoundedIcon from '@mui/icons-material/SendRounded';

type Props = {
  customMessage: string;
  onCustomMessageChange: (message: string) => void;
  defaultMessage: string;
  onSendTest: () => void;
  isLoading: boolean;
  disabled?: boolean;
  buttonText?: string;
  messageLabel?: string;
  messagePlaceholder?: string;
  helperText?: string;
};

const TestMessageSection = ({
  customMessage,
  onCustomMessageChange,
  defaultMessage,
  onSendTest,
  isLoading,
  disabled,
  buttonText = 'Send',
  messageLabel = 'Test message (optional)',
  messagePlaceholder,
  helperText = 'Leave empty to use the default test message',
}: Props) => (
  <>
    <TextField
      label={messageLabel}
      value={customMessage}
      onChange={(e) => onCustomMessageChange(e.target.value)}
      multiline
      rows={3}
      disabled={isLoading}
      placeholder={messagePlaceholder || defaultMessage}
      helperText={helperText}
    />

    <Flex sx={{ justifyContent: 'flex-end' }}>
      <LoadingButton
        onClick={onSendTest}
        variant="outlined"
        size="large"
        loading={isLoading}
        startIcon={!isLoading && <SendRoundedIcon sx={{ width: '18px' }} />}
        disabled={disabled}
      >
        {buttonText}
      </LoadingButton>
    </Flex>
  </>
);

export default TestMessageSection;
